import { render, staticRenderFns } from "./MainBox.vue?vue&type=template&id=345021a6&scoped=true"
import script from "./MainBox.vue?vue&type=script&lang=js"
export * from "./MainBox.vue?vue&type=script&lang=js"
import style0 from "./MainBox.vue?vue&type=style&index=0&id=345021a6&prod&lang=less"
import style1 from "./MainBox.vue?vue&type=style&index=1&id=345021a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345021a6",
  null
  
)

export default component.exports